import { render } from "./ExerciseTab.vue?vue&type=template&id=edd64512"
import script from "./ExerciseTab.vue?vue&type=script&lang=js"
export * from "./ExerciseTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__